var map = {
	"./1/bottom-right-1.png": "yg3k",
	"./2/bottom-right-1.png": "SEn5",
	"./3/bottom-right-1.png": "AG4v",
	"./4/bottom-right-1.png": "PF5h",
	"./5/bottom-right-1.png": "/6Ty",
	"./6/bottom-right-1.png": "5Df2",
	"./7/bottom-right-1.png": "1t49",
	"./8/bottom-right-1.png": "DYYG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5bVg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs ^\.\/.*\/bottom\-right\-1\.png$
// module id = 5bVg
// module chunks = 1